module.exports = __webpack_public_path__ + "img/Clock.a385ea44.svg";